<template>
  <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="仓库预登记详情"
      width="1200px"
      top="1vh">
    <div v-loading="contentLoading">
      <div class="section-title">基本信息</div>
      <table class="table">
        <tr>
          <td class="tableLabel">系统编号：</td>
          <td>{{warehousePreRegistrationVo.billNo}}</td>
          <td class="tableLabel">发起人：</td>
          <td>{{warehousePreRegistrationVo.creatorName}}</td>
          <td class="tableLabel">发起时间：</td>
          <td>{{warehousePreRegistrationVo.creatTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">退换货/客诉流程号（OA）/未来销售退货订单号（EMES/SAP）：</td>
          <td>{{warehousePreRegistrationVo.processNo}}</td>
          <td class="tableLabel">快递公司：</td>
          <td>{{warehousePreRegistrationVo.courierCompany}}</td>
          <td class="tableLabel">快递单号：</td>
          <td>{{warehousePreRegistrationVo.courierNo}}</td>
        </tr>
        <tr>
          <td class="tableLabel">客户名称：</td>
          <td colspan="5">{{warehousePreRegistrationVo.customerName}}</td>
        </tr>
      </table>
      
      <div class="section-title">明细信息</div>
      <el-table
          :data="warehousePreRegistrationVo.details"
          border>
        <el-table-column type="index" align="center" label="行号" width="60"/>
        <el-table-column prop="materialType" align="center" label="物料类型" width="120"/>
        <el-table-column prop="materialNo" align="center" label="物料编码" width="160"/>
        <el-table-column prop="materialName" align="center" label="物料名称" width="160"/>
        <el-table-column prop="materialSn" align="center" label="产品SN" width="160"/>
        <el-table-column prop="specifications" align="center" label="规格型号" width="160"/>
        <el-table-column prop="quantity" align="center" label="退货数量" width="100"/>
        <el-table-column prop="actualQuantity" align="center" label="实到数量" width="120"/>
        <el-table-column prop="actualDeliverTime" align="center" label="实际到货时间" width="160"/>
        <el-table-column prop="returnBillNo" align="center" label="返厂单号" width="180"/>
        <el-table-column prop="initDuty" align="center" label="初步判责" width="180"/>
        <el-table-column prop="locationNo" align="center" label="仓库编号" width="160"/>
      </el-table>
      
      <div
          v-if="!warehousePreRegistrationVo.details || warehousePreRegistrationVo.details.length === 0" 
          style="text-align: center; color: #999; padding: 20px;">
        暂无明细信息
      </div>
      
      <div class="section-title">附件信息</div>
      <div v-if="warehousePreRegistrationVo.attachments && warehousePreRegistrationVo.attachments.length > 0">
        <el-table
            :data="warehousePreRegistrationVo.attachments"
            border>
          <el-table-column type="index" align="center" label="行号" width="60"/>
          <el-table-column prop="fileName" align="center" label="图片" width="120">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述"/>
        </el-table>
      </div>
      <div
          v-else
          style="text-align: center; color: #999; padding: 20px;">
        暂无附件
      </div>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "WarehousePreRegistrationPreview",
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        imgUrls: [],
        warehousePreRegistrationVo: {
          details: [],
          attachments: [],
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row && row.pkid) {
          this.getData(row.pkid);
        } else {
          this.warehousePreRegistrationVo = {
            billNo: row.billNo || "",
            creatorName: row.creatorName || "",
            creatTime: row.creatTime || "",
            processNo: row.processNo || "",
            courierCompany: row.courierCompany || "",
            courierNo: row.courierNo || "",
            customerName: row.customerName || "",
            details: [],
          };
        }
      },
      getData(id) {
        this.contentLoading = true;
        this.$http.get("basic", `warehouseRegisters/${id}`).then((resp) => {
          if (resp.success) {
            this.warehousePreRegistrationVo = resp.data;
            // 确保details数组存在
            if (!this.warehousePreRegistrationVo.details) {
              this.warehousePreRegistrationVo.details = [];
            }
            // 处理附件信息
            if (this.warehousePreRegistrationVo.attachments) {
              this.warehousePreRegistrationVo.attachments.forEach(attachment => {
                this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(attachment.filePath)}`)
                  .then((urlResp) => {
                    if (urlResp.success) {
                      attachment.imgUrl = urlResp.data;
                      this.imgUrls.push(urlResp.data);
                    }
                  });
              });
            }
          }
        }).finally(() => {
          this.contentLoading = false;
        });
      },
    },
  };
</script>

<style scoped>
  .section-title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 10px 0;
    padding-bottom: 5px;
    border-bottom: 1px solid #dfe6ec;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .table tr {
    border-bottom: 1px solid #dfe6ec;
  }
  
  .table td {
    padding: 12px;
    border: 1px solid #dfe6ec;
    vertical-align: top;
  }
  
  .tableLabel {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: bold;
    width: 140px;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>